import { Box, Button, styled } from '@mui/material';

export const SidebarHeaderContainer = styled(Box)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
  padding: 20px 15px 0 15px;
`;

export const SidebarHeaderButton = styled(Button)(
  ({ theme }) => `
    padding: 0;
    color: ${theme.palette.text.primary};
    font-size: 1.25rem;
    font-weight: 400;

    overflow: hidden;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: start;
    `,
);
